import { Component } from "react";

/**
 * Filet de sécurité : sans lui, la moindre exception de rendu démonte tout
 * l'arbre React et laisse une page entièrement blanche.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Erreur de rendu :", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="eb-container">
        <div className="eb-card">
          <span className="rc-wordmark eb-brand">Racines</span>
          <h1>Une erreur est survenue</h1>
          <p>L'affichage a rencontré un problème. Rechargez la page pour continuer.</p>
          <button className="rc-btn rc-btn-primary" onClick={() => window.location.reload()}>
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
